import React from 'react';

const Copyright: React.FC<{ className?: string }> = (props) => (
  <span className={props.className}>© Asurion 1992–{new Date().getFullYear()}. All Rights Reserved.</span>
);

export default Copyright;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/Copyright.tsx